/**
 * @generated SignedSource<<9b6ec85a74dba52339f254fe496791ae>>
 * @relayHash 214c1b55891d24129a5a34fe0d6bc8af
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f32624664346b7b446d894f77463f210c4927fd4a6d2b4dc47c9663bf93fdeb0

import type { ConcreteRequest } from 'relay-runtime';
export type RovoOpsComponentQuery$variables = {
  cloudIdID: string;
  cloudIdString: string;
  coralogixDimensionIds: ReadonlyArray<string>;
  dynatraceDimensionIds: ReadonlyArray<string>;
  externalReference: string;
  honeycombDimensionIds: ReadonlyArray<string>;
  lansweeperDimensionIds: ReadonlyArray<string>;
  newRelicDimensionIds: ReadonlyArray<string>;
};
export type RovoOpsComponentQuery$data = {
  readonly agentStudio_getByExternalReference: {
    readonly id?: string;
  } | null;
  readonly agentStudio_tools: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly definitionId: string | null;
        readonly tags: ReadonlyArray<string> | null;
      } | null;
    }>;
  } | null;
  readonly rovoOpsCoralogixIntegrationItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id?: string;
      } | null;
    }>;
  } | null;
  readonly rovoOpsDynatraceIntegrationItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id?: string;
      } | null;
    }>;
  } | null;
  readonly rovoOpsHoneycombIntegrationItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id?: string;
      } | null;
    }>;
  } | null;
  readonly rovoOpsLansweeperIntegrationItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id?: string;
      } | null;
    }>;
  } | null;
  readonly rovoOpsNewRelicIntegrationItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id?: string;
      } | null;
    }>;
  } | null;
};
export type RovoOpsComponentQuery = {
  response: RovoOpsComponentQuery$data;
  variables: RovoOpsComponentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudIdID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudIdString"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "coralogixDimensionIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dynatraceDimensionIds"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "externalReference"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "honeycombDimensionIds"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lansweeperDimensionIds"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "newRelicDimensionIds"
},
v8 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudIdString"
},
v9 = [
  (v8/*: any*/),
  {
    "kind": "Variable",
    "name": "externalReference",
    "variableName": "externalReference"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = [
  (v10/*: any*/)
],
v12 = {
  "kind": "InlineFragment",
  "selections": (v11/*: any*/),
  "type": "AgentStudioAssistant"
},
v13 = [
  (v8/*: any*/),
  {
    "kind": "Literal",
    "name": "scenarioVersion",
    "value": 2
  }
],
v14 = {
  "kind": "ScalarField",
  "name": "definitionId"
},
v15 = {
  "kind": "ScalarField",
  "name": "tags"
},
v16 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudIdID"
},
v17 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v18 = {
  "kind": "Literal",
  "name": "relevantFor",
  "value": "MCP_SERVER"
},
v19 = [
  (v16/*: any*/),
  {
    "kind": "Variable",
    "name": "dimensionIds",
    "variableName": "newRelicDimensionIds"
  },
  (v17/*: any*/),
  (v18/*: any*/)
],
v20 = {
  "kind": "InlineFragment",
  "selections": (v11/*: any*/),
  "type": "GraphIntegrationMcpServer"
},
v21 = [
  {
    "concreteType": "GraphIntegrationDirectoryItemEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v20/*: any*/)
        ]
      }
    ]
  }
],
v22 = [
  (v16/*: any*/),
  {
    "kind": "Variable",
    "name": "dimensionIds",
    "variableName": "dynatraceDimensionIds"
  },
  (v17/*: any*/),
  (v18/*: any*/)
],
v23 = [
  (v16/*: any*/),
  {
    "kind": "Variable",
    "name": "dimensionIds",
    "variableName": "honeycombDimensionIds"
  },
  (v17/*: any*/),
  (v18/*: any*/)
],
v24 = [
  (v16/*: any*/),
  {
    "kind": "Variable",
    "name": "dimensionIds",
    "variableName": "coralogixDimensionIds"
  },
  (v17/*: any*/),
  (v18/*: any*/)
],
v25 = [
  (v16/*: any*/),
  {
    "kind": "Variable",
    "name": "dimensionIds",
    "variableName": "lansweeperDimensionIds"
  },
  (v17/*: any*/),
  (v18/*: any*/)
],
v26 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v27 = [
  {
    "concreteType": "GraphIntegrationDirectoryItemEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v26/*: any*/),
          (v20/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v11/*: any*/),
            "type": "GraphIntegrationActionDirectoryItem"
          },
          {
            "kind": "InlineFragment",
            "selections": (v11/*: any*/),
            "type": "GraphIntegrationMcpTool"
          },
          {
            "kind": "InlineFragment",
            "selections": (v11/*: any*/),
            "type": "GraphIntegrationSkillDirectoryItem"
          },
          {
            "kind": "InlineFragment",
            "selections": (v11/*: any*/),
            "type": "GraphIntegrationSkillItem"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "RovoOpsComponentQuery",
    "selections": [
      {
        "args": (v9/*: any*/),
        "kind": "LinkedField",
        "name": "agentStudio_getByExternalReference",
        "plural": false,
        "selections": [
          (v12/*: any*/)
        ]
      },
      {
        "args": (v13/*: any*/),
        "concreteType": "AgentStudioToolsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_tools",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentStudioToolEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentStudioTool",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v15/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "rovoOpsNewRelicIntegrationItems",
        "args": (v19/*: any*/),
        "concreteType": "GraphIntegrationDirectoryItemConnection",
        "kind": "LinkedField",
        "name": "graphIntegration_componentDirectoryItems",
        "plural": false,
        "selections": (v21/*: any*/)
      },
      {
        "alias": "rovoOpsDynatraceIntegrationItems",
        "args": (v22/*: any*/),
        "concreteType": "GraphIntegrationDirectoryItemConnection",
        "kind": "LinkedField",
        "name": "graphIntegration_componentDirectoryItems",
        "plural": false,
        "selections": (v21/*: any*/)
      },
      {
        "alias": "rovoOpsHoneycombIntegrationItems",
        "args": (v23/*: any*/),
        "concreteType": "GraphIntegrationDirectoryItemConnection",
        "kind": "LinkedField",
        "name": "graphIntegration_componentDirectoryItems",
        "plural": false,
        "selections": (v21/*: any*/)
      },
      {
        "alias": "rovoOpsCoralogixIntegrationItems",
        "args": (v24/*: any*/),
        "concreteType": "GraphIntegrationDirectoryItemConnection",
        "kind": "LinkedField",
        "name": "graphIntegration_componentDirectoryItems",
        "plural": false,
        "selections": (v21/*: any*/)
      },
      {
        "alias": "rovoOpsLansweeperIntegrationItems",
        "args": (v25/*: any*/),
        "concreteType": "GraphIntegrationDirectoryItemConnection",
        "kind": "LinkedField",
        "name": "graphIntegration_componentDirectoryItems",
        "plural": false,
        "selections": (v21/*: any*/)
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "RovoOpsComponentQuery",
    "selections": [
      {
        "args": (v9/*: any*/),
        "kind": "LinkedField",
        "name": "agentStudio_getByExternalReference",
        "plural": false,
        "selections": [
          (v26/*: any*/),
          (v12/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v11/*: any*/),
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ]
      },
      {
        "args": (v13/*: any*/),
        "concreteType": "AgentStudioToolsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_tools",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentStudioToolEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentStudioTool",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v10/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "rovoOpsNewRelicIntegrationItems",
        "args": (v19/*: any*/),
        "concreteType": "GraphIntegrationDirectoryItemConnection",
        "kind": "LinkedField",
        "name": "graphIntegration_componentDirectoryItems",
        "plural": false,
        "selections": (v27/*: any*/)
      },
      {
        "alias": "rovoOpsDynatraceIntegrationItems",
        "args": (v22/*: any*/),
        "concreteType": "GraphIntegrationDirectoryItemConnection",
        "kind": "LinkedField",
        "name": "graphIntegration_componentDirectoryItems",
        "plural": false,
        "selections": (v27/*: any*/)
      },
      {
        "alias": "rovoOpsHoneycombIntegrationItems",
        "args": (v23/*: any*/),
        "concreteType": "GraphIntegrationDirectoryItemConnection",
        "kind": "LinkedField",
        "name": "graphIntegration_componentDirectoryItems",
        "plural": false,
        "selections": (v27/*: any*/)
      },
      {
        "alias": "rovoOpsCoralogixIntegrationItems",
        "args": (v24/*: any*/),
        "concreteType": "GraphIntegrationDirectoryItemConnection",
        "kind": "LinkedField",
        "name": "graphIntegration_componentDirectoryItems",
        "plural": false,
        "selections": (v27/*: any*/)
      },
      {
        "alias": "rovoOpsLansweeperIntegrationItems",
        "args": (v25/*: any*/),
        "concreteType": "GraphIntegrationDirectoryItemConnection",
        "kind": "LinkedField",
        "name": "graphIntegration_componentDirectoryItems",
        "plural": false,
        "selections": (v27/*: any*/)
      }
    ]
  },
  "params": {
    "id": "f32624664346b7b446d894f77463f210c4927fd4a6d2b4dc47c9663bf93fdeb0",
    "metadata": {},
    "name": "RovoOpsComponentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4b58988de23ee7bb35bacc30da736af2";

export default node;
